import React from 'react';
import gs from '../../../../styles/globalStyles';
import Button from '../../../../sharedComponents/Button/Button';
import SystemWarning from '../../../../../assets/Icons/SystemWarning';
import { X } from '../../../../sharedComponents/Icons';
import Typography from '@app/sharedComponents/typography/Typography';
import {
  TypographyTypeDLS,
  TextAlignTokens
} from '@voltmoney/schema';
import { ThemedView, ThemedPressable } from '@app/theme';
const ConfirmEditLimit = ({
  ctaAction1 = () => {},
  ctaAction2 = () => {},
  onClose = () => {},
  buttonLoader = false,
}) => {
  return (
    <ThemedView p="lg" mt="sm">
      <ThemedView flexDirection='row' justifyContent='center'>
        <ThemedView width={24} />
        <SystemWarning />
        {/* <ThemedPressable onPress={onClose}>
          <X size={24} />
        </ThemedPressable> */}
      </ThemedView>

      <ThemedView my="2xl">
          <Typography
              typeDLS={TypographyTypeDLS.H4S}
              label={"Are you sure you want to edit your limit? This will reset your selected limit"}
              textAlign={TextAlignTokens.center}
          />
      </ThemedView>
      <ThemedView mb="md">
        <Button
          eventName='DASHBOARD_EDIT_LIMIT_YES_CLICKED'
          label={'Yes, continue to edit limit'}
          type={'SOLID'}
          handlePress={ctaAction1}
          size={'MD'}
          buttonLoader={buttonLoader}
        />
      </ThemedView>
      <Button
        eventName='DASHBOARD_EDIT_LIMIT_NO_CLICKED'
        label={'No, continue with selected limit'}
        type={'OUTLINED'}
        handlePress={ctaAction2}
        size={'MD'}
      />
    </ThemedView>
  );
};

export default ConfirmEditLimit;
